import { render, staticRenderFns } from "./ckEditor.vue?vue&type=template&id=33b0ec4e"
import script from "./ckEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ckEditor.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports